import RegulamentoComponent from './regulamento.component'

export default RegulamentoComponent
